import useSWRImmutable from 'swr/immutable';
import ActivityService from '@/services/TourServices/ActivityService';

const useActivityDaysOfWeek = () => useSWRImmutable(
    'activity-days-of-week',
    ActivityService.getDaysOfWeek,
);

export default useActivityDaysOfWeek;
